import { userRoles } from '../../constants';
import { fields, createSchema, validate as _validate } from '..';

const { email, loginPassword, learnerUniqueId, emailOrCoachUniqueId } = fields;

const schema = createSchema({
  email,
  password: loginPassword,
});

const learnerSchema = createSchema({
  learnerUniqueId,
});

const inPrisonSchema = createSchema({
  email: emailOrCoachUniqueId,
  password: loginPassword,
});

const validate = (data) => {
  if (data.role === userRoles.LEARNER) {
    return _validate(learnerSchema, data);
  }

  if (data.isWorkingInPrisonEnvironment) {
    return _validate(inPrisonSchema, data);
  }

  return _validate(schema, data);
};

export default validate;
